import type { Loadable } from '@/loadingUtils'
import type { Teach } from '@pocketprep/types'

export interface IGroupModuleState {
    currentOrgGroups: { [key: string]: Loadable<{ [key: string]: Teach.Class.OrgGroupJSON }> | undefined }
    currentGroupId: string | null
}

export const getInitialGroupState = (): IGroupModuleState => {
    return {
        currentOrgGroups: {},
        currentGroupId: null,
    }
}

const moduleState = getInitialGroupState()

export default moduleState
